import SiteHeader from './components/site-header';
import HandheldMenu from './components/handheld-menu';
import CookiesConsent from './components/cookies-consent';
import DeviceManager from './utils/device-manager';

const onDOMReady = () => {
	const bootstrapApp = () => {
		const html = document.querySelector('html');

		// Touch device detection
		if(DeviceManager.isHandheld()) {
			html.classList.add('touch');

			if(DeviceManager.isIos()) {
				html.classList.add('ios');
			}
		} 
        else {
			html.classList.add('no-touch');
		}

		// IE detection
		if(DeviceManager.isIe11()) {
			html.classList.add('ie11');
		} 
        else if(DeviceManager.isEdge()) {
			html.classList.add('edge');
		}
	};

	const instanciateComponents = async () => {
		// Header
		const siteHeader = new SiteHeader(document.querySelector('.site-header'));

		// Home slider component
		const featuredProjectsSlider = document.querySelector('.featured-projects-slider');
		if (featuredProjectsSlider) {
            import(/* webpackChunkName: "featured-projects-slider" */ './components/featured-projects-slider').then((FeaturedProjectsSlider) => {
                const slider = new FeaturedProjectsSlider.default(featuredProjectsSlider.parentNode);
            });
		}

        // Sentence reveal component
        const sentence = document.querySelector('.sentence-reveal');
        if (sentence) {
            import(/* webpackChunkName: "sentence-reveal" */ './components/sentence-reveal').then((SentenceReveal) => {
                const sentenceReveal = new SentenceReveal.default(sentence);
            });
        }

        // Services list component
        const servicesLists = [...document.querySelectorAll('.services-list')];
        if (servicesLists.length) {
            import(/* webpackChunkName: "services-list" */ './components/services-list').then((ServicesList) => {
                servicesLists.forEach((servicesList) => {
                    const list = new ServicesList.default(servicesList);
                })
            });
        }

        // Projects list component
        const projectsList = document.querySelector('.projects-list');
        const projectsFilters = document.querySelector('.projects-filters');
        if (projectsList && projectsFilters) {
            import(/* webpackChunkName: "projects-list" */ './components/projects-list').then((ProjectsList) => {
                const list = new ProjectsList.default(projectsList, projectsFilters);
            });
        }

        // Related projects slider component
        const relatedProjectsSlider = document.querySelector('.related-projects-slider');
        if (relatedProjectsSlider) {
            import(/* webpackChunkName: "related-projects-slider" */ './components/related-projects-slider').then((RelatedProjectsSlider) => {
                const slider = new RelatedProjectsSlider.default(relatedProjectsSlider);
            });
        }

        // Project details popup component
        const projectDetailsPopup = document.querySelector('.project__details-popup');
        const projectsDetailsButton = document.querySelector('.project__details-button');
        if (projectDetailsPopup && projectsDetailsButton) {
            import(/* webpackChunkName: "project-details-popup" */ './components/project-details-popup').then((ProjectDetailsPopup) => {
                const popup = new ProjectDetailsPopup.default(projectDetailsPopup, projectsDetailsButton);
            });
        }

        // Departments dropdown component
        const departmentsDropdown = document.querySelector('.departments-dropdown');
        if (departmentsDropdown) {
            import(/* webpackChunkName: "departments-dropdown" */ './components/departments-dropdown').then((DepartmentsDropdown) => {
                const dropdown = new DepartmentsDropdown.default(departmentsDropdown);
            });
        }

		// Cookie consent
		if(typeof tarteaucitron !== 'undefined' && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = 'fr';

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}
	};

	bootstrapApp;
	instanciateComponents();
};

if(document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', onDOMReady);
}
else {
    onDOMReady();
}

